(() => {
  const PANEL_SELECTOR =
    "[data-joans-gift-card-purchase]";

  function initialisePanels(root = document) {
    root
      .querySelectorAll(PANEL_SELECTOR)
      .forEach(initialisePanel);
  }

  function initialisePanel(panel) {
    if (
      panel.dataset.joansGiftCardInitialised ===
      "true"
    ) {
      return;
    }

    const productForm = panel.closest("form");

    const productSection =
  panel.closest('[id^="shopify-section-"]') ||
  document;

const variantsScript =
  panel.querySelector(
    "[data-joans-gift-card-variants]"
  );

    const optionGroups = Array.from(
      panel.querySelectorAll(
        "[data-joans-gift-card-option]"
      )
    );

    const optionButtons = Array.from(
      panel.querySelectorAll(
        "[data-joans-gift-card-option-button]"
      )
    );

    /*
     * Keep Joan's custom denomination buttons connected
     * to Horizon's native variant picker.
     */
    const nativeVariantPicker =
  productSection.querySelector(
    "variant-picker"
  ) ||
  document.querySelector(
    "variant-picker"
  );

    const nativeVariantInput =
      productForm?.querySelector(
        'input[name="id"]'
      ) || null;

    /*
     * Do not hide or replace anything unless all the
     * essential native Shopify pieces are present.
     */
    if (
      !productForm ||
      !variantsScript ||
      !nativeVariantPicker ||
      !nativeVariantInput ||
      optionButtons.length === 0
    ) {
      console.error(
        "Joan's: gift card purchase panel could not initialise."
      );

      return;
    }

    let variants = [];

    try {
      variants = JSON.parse(
        variantsScript.textContent
      );
    } catch (error) {
      console.error(
        "Joan's: gift card variant data could not be read.",
        error
      );

      return;
    }

    if (
      !Array.isArray(variants) ||
      variants.length === 0
    ) {
      console.error(
        "Joan's: no gift card variants were found."
      );

      return;
    }

    const initialVariantId =
      String(
        panel.dataset.initialVariantId || ""
      );

    let currentVariant =
      variants.find(
        (variant) =>
          String(variant.id) ===
          initialVariantId
      ) || variants[0];

    const selectedOptions =
      Array.isArray(currentVariant.options)
        ? [...currentVariant.options]
        : [];

    function updateOptionButtons() {
      optionButtons.forEach((button) => {
        const position =
          Number(
            button.dataset.optionPosition
          ) - 1;

        const isSelected =
          String(
            selectedOptions[position]
          ) ===
          String(
            button.dataset.optionValue
          );

        button.classList.toggle(
          "is-selected",
          isSelected
        );

        button.setAttribute(
          "aria-pressed",
          isSelected
            ? "true"
            : "false"
        );
      });
    }

    function findSelectedVariant() {
      return (
        variants.find((variant) => {
          if (
            !Array.isArray(variant.options)
          ) {
            return false;
          }

          return selectedOptions.every(
            (selectedValue, index) =>
              String(
                variant.options[index]
              ) ===
              String(selectedValue)
          );
        }) || null
      );
    }

    function syncHorizonVariantPicker(button) {
      const optionPosition =
        String(
          button.dataset.optionPosition || ""
        );

      const optionValue =
        String(
          button.dataset.optionValue || ""
        );

      if (
        !optionPosition ||
        !optionValue
      ) {
        return;
      }

      /*
       * Horizon identifies its native option controls
       * using "{option position}-{value index}".
       *
       * We find the matching native option and let
       * Horizon process its normal change event.
       */
      const nativeChoices =
        Array.from(
          nativeVariantPicker.querySelectorAll(
            `[data-input-id^="${optionPosition}-"]`
          )
        );

      const nativeChoice =
        nativeChoices.find(
          (choice) =>
            String(choice.value) ===
            optionValue
        );

      if (
        nativeChoice instanceof
        HTMLInputElement
      ) {
        if (!nativeChoice.checked) {
          nativeChoice.dispatchEvent(
            new Event(
              "change",
              { bubbles: true }
            )
          );
        }

        return;
      }

      if (
        nativeChoice instanceof
        HTMLOptionElement
      ) {
        const nativeSelect =
          nativeChoice.closest("select");

        if (!nativeSelect) {
          return;
        }

        if (
          String(nativeSelect.value) !==
          optionValue
        ) {
          nativeSelect.value =
            nativeChoice.value;

          nativeSelect.dispatchEvent(
            new Event(
              "change",
              { bubbles: true }
            )
          );
        }
      }
    }

    function selectOption(button) {
      const position =
        Number(
          button.dataset.optionPosition
        ) - 1;

      const value =
        button.dataset.optionValue;

      if (
        position < 0 ||
        value === undefined
      ) {
        return;
      }

      selectedOptions[position] =
        value;

      const selectedVariant =
        findSelectedVariant();

      if (!selectedVariant) {
        return;
      }

      currentVariant =
        selectedVariant;

      /*
       * Keep Shopify's actual product form variant ID
       * correct for Add to Cart.
       */
      nativeVariantInput.value =
        String(currentVariant.id);

      updateOptionButtons();

      /*
       * Also tell Horizon about the change so its own
       * variant state stays synchronised.
       */
      syncHorizonVariantPicker(button);
    }

    optionButtons.forEach(
      (button) => {
        button.addEventListener(
          "click",
          () => {
            selectOption(button);
          }
        );
      }
    );

    updateOptionButtons();

    /*
     * Everything is successfully connected.
     * NOW it is safe to hide Horizon's duplicate picker.
     */
    nativeVariantPicker.classList.add(
  "joans-gift-card-native-picker--hidden"
);

productForm.classList.add(
  "joans-gift-card-form--enhanced"
);

panel.dataset.joansGiftCardInitialised =
  "true";
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      () => initialisePanels()
    );
  } else {
    initialisePanels();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      initialisePanels(event.target);
    }
  );
})();